/* ==========================================================
   nv-cart-fix.js — remoção/alteração de itens do carrinho
   - usa a key da linha (id) em vez da posição (line)
   - trava clique duplo por item e executa pedidos em fila
   - erro amigável em PT-BR + ressincroniza com o carrinho real
   - garante contador da sacola atualizado
   Sobrescreve Shopify.removeItem / Shopify.changeItem (global.js)
   mantendo a mesma assinatura usada pelo theme.js.
   ========================================================== */
(function () {
  'use strict';
  if (!window.Shopify) window.Shopify = {};

  var ERROR_MSG = 'Não foi possível atualizar o carrinho. Tente novamente.';
  var pending = {};          /* keys/linhas com requisição em andamento */
  var queue = Promise.resolve();

  /* ---------- estilo do estado "carregando" ---------- */
  try {
    var st = document.createElement('style');
    st.textContent =
      '[data-cart-remove][aria-busy="true"],[data-cart-quantity][aria-busy="true"]{opacity:.45;pointer-events:none;cursor:progress}';
    document.head.appendChild(st);
  } catch (e) {}

  function isKey(v) { return typeof v === 'string' && v.indexOf(':') !== -1; }

  function changeUrl() {
    return (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change.js';
  }

  function warn(msg) {
    try {
      if (typeof window.showWarning === 'function') { window.showWarning(msg, 3000); return; }
    } catch (e) {}
    try { if (window.NV && NV.toast) { NV.toast(msg); return; } } catch (e) {}
  }

  function setCount(n) {
    try { if (window.NV && NV.setCartCount) NV.setCartCount(n); } catch (e) {}
    try {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    } catch (e) {}
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  function markBusy(ref, on) {
    if (ref === undefined || ref === null) return;
    var sel = '[data-cart-remove][data-line="' + String(ref).replace(/"/g, '') + '"],' +
              '[data-cart-quantity][data-line="' + String(ref).replace(/"/g, '') + '"]';
    try {
      document.querySelectorAll(sel).forEach(function (el) {
        if (on) el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy');
      });
    } catch (e) {}
  }

  function finish(cart, callback) {
    if (cart && typeof cart.item_count === 'number') setCount(cart.item_count);
    if (typeof callback === 'function') {
      try { callback(cart); } catch (e) { console.error(e); }
    }
    var body = document.body;
    /* fora da /cart e com o lateral fechado o callback do tema não redesenha nada */
    if (body && !body.classList.contains('template-cart') && !body.classList.contains('cart-sidebar-show')) {
      try {
        if (window.sharedFunctions && sharedFunctions.updateSidebarCart && document.getElementById('halo-cart-sidebar')) {
          sharedFunctions.updateSidebarCart(cart);
        }
      } catch (e) {}
    }
  }

  /* ---------- requisição principal ---------- */
  function updateLine(ref, index, quantity, callback) {
    var lock = isKey(ref) ? ref : 'line-' + index;
    if (pending[lock]) return;            /* clique repetido no mesmo item: ignora */
    pending[lock] = true;
    markBusy(ref, true);

    var payload = isKey(ref)
      ? { id: ref, quantity: quantity }
      : { line: parseInt(index, 10), quantity: quantity };

    queue = queue.then(function () {
      return fetch(changeUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          return r.text().then(function (t) {
            var data = null;
            try { data = JSON.parse(t); } catch (e) {}
            if (!r.ok || !data || data.errors || data.status >= 400) {
              var err = new Error('cart-change');
              err.data = data;
              throw err;
            }
            return data;
          });
        })
        .then(function (cart) { finish(cart, callback); })
        .catch(function (err) {
          console.error('[nv-cart-fix]', err && err.data ? err.data : err);
          var desc = err && err.data && (err.data.description || err.data.message);
          /* mensagem de estoque da Shopify já vem em PT-BR; senão, texto padrão */
          warn(desc && typeof desc === 'string' && desc.length < 160 ? desc : ERROR_MSG);
          /* ressincroniza: redesenha com o estado real (remove overlays travados) */
          return fetchCart()
            .then(function (cart) { finish(cart, callback); })
            .catch(function () {});
        })
        .then(function () {
          delete pending[lock];
          markBusy(ref, false);
        });
    });
  }

  Shopify.removeItem = function (ref, index, callback) {
    updateLine(ref, index, 0, callback);
  };

  Shopify.changeItem = function (ref, quantity, index, callback) {
    var q = parseInt(quantity, 10);
    if (isNaN(q) || q < 0) q = 0;
    updateLine(ref, index, q, callback);
  };

  /* ---------- trava antes do handler do tema (fase de captura) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cart-remove]') : null;
    if (!btn) return;
    var ref = btn.getAttribute('data-line');
    var lock = isKey(ref) ? ref : 'line-' + btn.getAttribute('data-index');
    if (pending[lock] || btn.getAttribute('aria-busy') === 'true') {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
})();
